import { Header } from "@/components/layout/Header";
import { Sidebar } from "@/components/layout/Sidebar";
import { MobileBottomNav } from "@/components/layout/MobileBottomNav";
import { ReactNode } from "react";

interface PageLayoutProps {
  children: ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "6xl" | "full";
  noPadding?: boolean;
}

export function PageLayout({ children, maxWidth = "6xl", noPadding = false }: PageLayoutProps) {
  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "6xl": "max-w-6xl",
    full: "max-w-full",
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 min-w-0 pb-20 lg:pb-0">
          <div className={noPadding ? "" : `p-4 lg:p-6 ${maxWidthClasses[maxWidth]} mx-auto`}>
            {children}
          </div>
        </main>
      </div>
      <MobileBottomNav />
    </div>
  );
}
